import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/fonts.css";
import "./styles/portal.css";
import "./styles/app.css";
// Revision 5 (Probelauf): Look des Original-Portals; lädt als letzte Stilebene
import "./styles/original.css";
import "./styles/buehne.css"; // Design-Pilot „Bühne“: wirkt nur mit html[data-look="buehne"] (Variante B: data-hell="1")
import "./styles/kompakt.css"; // Kompakt-Ebene für alle Seiten (D-1, Inhaber 21.10.2026)
import "./styles/dichte.css"; // Dichte-Token-Blatt D-2: Tabellen, Zeilenaktionen, Seitenkopf, Karten (Inhaber 21.10.2026)
import "./styles/glas.css"; // Premium-Design „Glas“ (Inhaber 27.10.2026): wirkt nur mit html[data-glas], Schalter ?look=glas
import { App } from "./app/App";
import { api, apiBereit } from "./data";
import { setupPwa } from "./pwa";
import { setupFehlerbericht } from "./lib/fehlerbericht";
import { setupMelden } from "./lib/melden";

/**
 * Nur im Demo-Modus: `?demo=<e-mail>` meldet eine Demo-Person ohne Umweg über die Anmeldeseite an.
 * Das nutzen die Einbettungen der Website (`?embed=1&demo=…`) und die Bildschirmfotos. Mit Supabase wirkungslos.
 */
async function demoLogin() {
  if (api.mode !== "demo") return;
  const who = new URLSearchParams(location.search).get("demo");
  if (!who) return;
  try {
    await api.signInWithPassword(who, "");
  } catch {
    /* unbekannte Person: normale Anmeldeseite */
  }
}

// Fehlerberichte (0158): nur im Betrieb mit Supabase; Demo und Dev-Server melden nichts
setupFehlerbericht({
  aktiv: api.mode === "supabase" && !import.meta.env.DEV,
  release: String(import.meta.env.VITE_RELEASE ?? "lokal"),
  // read statt rpc: ein Bericht ist keine Datenänderung und darf keine Abfragen neu laden
  senden: (b) => api.read("report_client_error", { p_report: b }),
});

// „Melden“ (0176): letzte Schritte und technische Spuren nur im Speicher dieser Seite, gesendet erst auf Klick
setupMelden();

// Installierbare App: Manifest je Portal; Service Worker nur im Betrieb (nie im Dev-Server, nie in der Demo)
setupPwa({ dev: import.meta.env.DEV, demo: api.mode === "demo" });

// Demo: erst den nachgeladenen Demo-Anschluss abwarten (PGlite liegt nicht im Hauptbündel); bis dahin steht der Ladeschirm
// aus index.html. Scheitert das Nachladen, zeichnet die App trotzdem; jede Abfrage versucht es dann erneut.
void apiBereit().catch(() => undefined).then(demoLogin).then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
